module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video_bg_3-4ef9124696dc5e6fe86e36c3291c6515.svg";